const SCHNEIDER_VIDEO_SHA256 =
  '4b2c813818e4bc791898d509542648d3e5adf22d766e852cece26028a1ed72b5'

/**
 * Compile-time protection for content manifests.
 *
 * The physical-file check loads content/policies/material-denylist-v0.1.1.json
 * during content preparation. Keeping the known hash here also prevents a
 * forbidden asset from entering a manifest before its file is inspected.
 */
export const forbiddenMediaSha256 = new Set<string>([
  SCHNEIDER_VIDEO_SHA256
])

export function isForbiddenMediaSha256(value: string): boolean {
  return forbiddenMediaSha256.has(value.trim().toLowerCase())
}
